// extracted by mini-css-extract-plugin
export default {"wrapperDrawerShrunk":"DrawerNavigation_wrapperDrawerShrunk__7FD84","hamburgerIcon":"DrawerNavigation_hamburgerIcon__8eWKI"};